// Utility functions for booking management

export function generateBookingReference(): string {
  const timestamp = Date.now().toString(36);
  const randomStr = Math.random().toString(36).substring(2, 8);
  return `BE-${timestamp}-${randomStr}`.toUpperCase();
}

export function formatAppointmentDateTime(date: Date, time: string): string {
  const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
  return `${dateStr}T${time}:00`;
}

export function validateBookingData(data: any): { isValid: boolean; errors: string[] } {
  const errors: string[] = [];

  if (!data.customerName?.trim()) {
    errors.push('Customer name is required');
  }

  if (!data.customerEmail?.trim()) {
    errors.push('Email address is required');
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.customerEmail)) {
    errors.push('Valid email address is required');
  }

  if (!data.customerPhone?.trim()) {
    errors.push('Phone number is required');
  }

  if (!data.serviceType?.trim()) {
    errors.push('Service type is required');
  }

  if (!data.appointmentDate) {
    errors.push('Appointment date is required');
  }

  if (!data.appointmentTime?.trim()) {
    errors.push('Appointment time is required');
  }

  if (!data.paymentAmount || data.paymentAmount <= 0) {
    errors.push('Valid payment amount is required');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
}

export function formatCurrency(amount: number, currency: string = 'DKK'): string {
  return new Intl.NumberFormat('da-DK', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  }).format(amount / 100);
}